(function($) {
    class W4D_AvailabilityNotify {
        constructor() {
            this.initSelectors();
            this.bindEvents();
            this.cacheInitialTemplate();
        }

        initSelectors() {
            this.availabilityFormSelector = '#availability_notify_form';
            this.availabilityDialogSelector = '[data-modal="availability-notify"]';
            this.availabilityBtn = '.availability-notify__dialog-open-btn';
        }

        bindEvents() {
            $(document).on('submit', this.availabilityFormSelector, (e) => this.handleSubmit(e));
            $(document).on('input', `${this.availabilityFormSelector} input[name="email"]`, (e) => this.onEmailInput(e));
            $(document).on('click', this.availabilityBtn, (e) => this.handleAvailabilityBtnClick(e.currentTarget));
        }

        cacheInitialTemplate() {
            this.dialog = document.querySelector(this.availabilityDialogSelector);
            this.initialDialogHTML = this.dialog ? this.dialog.innerHTML : '';
        }

        resetDialog() {
            if (!this.dialog || !this.initialDialogHTML) return;
            this.dialog.innerHTML = this.initialDialogHTML;
        }

        handleAvailabilityBtnClick(btn) {
            this.resetDialog();
            const productId = btn.getAttribute('data-product-id') || '';
            const variationId = btn.getAttribute('data-variation-id') || '';

            const form = document.querySelector(this.availabilityFormSelector);
            if (form) {
                const productIdInput = form.querySelector('input[name="product_id"]');
                productIdInput.value = variationId ? variationId : productId;
            }
        }

        onEmailInput(e) {
            const form = e.target.closest('form');
            this.clearValidationError(form);
        }

        showValidationError(form, message) {
            let errorElement = form.querySelector('.availability-notify__validation-msg');

            if (!errorElement) {
                errorElement = document.createElement('p');
                errorElement.className = 'availability-notify__validation-msg';

                const emailLabel = form.querySelector('label');
                emailLabel.insertAdjacentElement('afterbegin', errorElement);
            }

            errorElement.textContent = message;
            errorElement.classList.add('error-msg');

            const emailInput = form.querySelector('input[name="email"]');
            emailInput.focus();
        }

        clearValidationError(form) {
            const existingError = form.querySelector('.availability-notify__validation-msg');
            if (existingError) {
                existingError.textContent = '';
                existingError.classList.remove('error-msg');
            }
        }

        handleSubmit(e) {
            e.preventDefault();

            const form = e.target;
            const formData = new FormData(form);
            const submitButton = form.querySelector('button[type="submit"]');
            const loader = submitButton.querySelector('.loader-1');

            const email = formData.get('email');
            const productId = formData.get('product_id');

            if (!email || email.trim() === '') {
                this.showValidationError(form, 'Molimo unesite vašu e-mail adresu.');
                return;
            }

            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailPattern.test(email)) {
                this.showValidationError(form, 'Unesite ispravnu e-mail adresu.');
                return;
            }

            this.clearValidationError(form);

            const ajaxData = {
                action: 'w4d_save_notify_email',
                nonce: w4d_frontend_ajax.nonce,
                email: email,
                product_id: productId
            }

            $.post({
                url: w4d_frontend_ajax.ajax_url,
                data: ajaxData,
                beforeSend: () => {
                    submitButton.disabled = true;
                    loader.style.display = 'block';
                },
                success: (res) => {
                    if (res.success) {
                        // Navigate up 2 levels from form to modal
                        const dialog = $(form).parent().parent()[0];
                        if (dialog) {
                            dialog.innerHTML = res.data.html;
                        }
                    } else {
                        this.showValidationError(form, res.data.message || 'Došlo je do greške.');
                    }
                },
                error: () => {
                    this.showValidationError(form, 'Greška pri slanju zahtjeva.');
                },
                complete: () => {
                    submitButton.disabled = false;
                    loader.style.removeProperty('display');
                }
            });
        }
    }

    $(document).ready(() => {
        new W4D_AvailabilityNotify();
    });
})(jQuery);